import React from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/style.css';

function Chevron({ orientation }) {
  const isLeft = orientation === 'left';
  const path = isLeft ? 'M10 3 L5 8 L10 13' : 'M6 3 L11 8 L6 13';
  return (
    <svg
      className="dr-chevron"
      viewBox="0 0 16 16"
      width="16"
      height="16"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d={path}
        stroke="currentColor"
        strokeWidth="1.7"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MonthCaption({ calendarMonth }) {
  const date = calendarMonth && calendarMonth.date;
  let label = '';
  if (date instanceof Date && !Number.isNaN(date.getTime())) {
    label = date.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric'
    });
  }
  return <span className="dr-caption-label">{label}</span>;
}

function DateRangeCalendar({ selected, onSelect, defaultMonth }) {
  const hasSelection = Boolean(selected && (selected.from || selected.to));
  const rdpSelected = hasSelection ? selected : undefined;

  return (
    <div className="dr-calendar">
      <DayPicker
        mode="range"
        selected={rdpSelected}
        onSelect={onSelect}
        numberOfMonths={1}
        defaultMonth={defaultMonth}
        showOutsideDays
        className="dr-rdp"
        components={{ Chevron, MonthCaption }}
      />
    </div>
  );
}

export default DateRangeCalendar;
